import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  _id: '1',
  title: '',
  name: '',
  author: '',
  coverImage: '',
  description: '',
  subject: '',
  chapters: [
    {
      title: '',
      description: '',
      sections: [{ title: '', description: '', paragraphs: [{}] }],
    },
  ],
  activities: [],
  activitiesSet: null,
  book: { book: {}, chapters: [], activities: [] },
};

const slice = createSlice({
  name: 'book',
  initialState,

  reducers: {
    setMyBook: (state, action) => {
      state.book = action.payload;
    },

    setBook: (state, action) => {
      state._id = action.payload._id;
      state.name = action.payload.name;
      state.title = action.payload.title;
      state.author = action.payload.author || '';
      state.subject = action.payload.subject;
      state.coverImage = action.payload.coverImage;
      state.activitiesSet = action.payload.activitiesSet;
      state.owner = action.payload.owner;
    },
    resetBook: (state) => {
      state = initialState;
    },
    setChapters: (state, action) => {
      if (Array.isArray(action.payload) && action.payload.length) {
        state.chapters = action.payload;
      } else {
        state.chapters = [
          {
            title: '',
            description: '',
            sections: [{ title: '', description: '', paragraphs: [{}] }],
          },
        ];
      }
    },
    pushActivity: (state, action) => {
      state.activities = [...state.activities, action.payload];
    },
    setActivities: (state, action) => {
      state.activities = action.payload;
      state.book.activities = action.payload;
    },
    replaceActivity: (state, action) => {
      const { activity, index } = action.payload;
      const updatedActs = [...state.activities];
      updatedActs[index] = { ...activity };
      state.activities = updatedActs;
    },
    setActivitiesSet: (state, action) => {
      state.activitiesSet = action.payload;
    },
  },
});

export const { setBook, resetBook, setChapters, pushActivity, setActivities, replaceActivity, setActivitiesSet } = slice.actions;
export const bookActions = slice.actions;
export default slice.reducer;
